import { existsSync, readFileSync } from 'node:fs';
import { dirname, resolve } from 'node:path';
import { fileURLToPath } from 'node:url';

let cachedRoot: string | undefined;

export function packageRoot(): string {
  if (cachedRoot) return cachedRoot;
  const moduleDirectory = dirname(fileURLToPath(import.meta.url));
  const candidates = [
    resolve(moduleDirectory, '..'),
    resolve(moduleDirectory, '..', '..'),
    resolve(process.cwd()),
  ];
  for (const candidate of candidates) {
    const packageJson = resolve(candidate, 'package.json');
    if (!existsSync(packageJson)) continue;
    try {
      const data = JSON.parse(readFileSync(packageJson, 'utf8')) as { name?: string };
      if (data.name === '@zaparoo/cli') {
        cachedRoot = candidate;
        return candidate;
      }
    } catch {
      // Continue searching deterministic package-root candidates.
    }
  }
  throw new Error('Unable to locate @zaparoo/cli package files');
}
